// toFixed strips floating point noise (e.g. 1.1 * 100 = 110.00000000000001)
// so it isn't rounded up to an extra cent
export const roundUpToTwoDecimals = (price: number): number =>
  Math.ceil(Number((price * 100).toFixed(6))) / 100;
